import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(${this.scroll.viewbox.x},0)`)
      .attr('font-family', 'roboto')

      if(this.title.main.visible == 'Y') {
        this.canvasForms
        .append('text')
        .attr('transform', `translate(${this.title.main.x}, ${this.title.main.y})`)
        .attr('font-size', this.title.main.tSize).attr('fill', this.title.main.tColor)
        .text(this.title.main.name)
      }

      if(this.title.sub.visible == 'Y') {
        this.canvasForms
       .append('text')
        .attr('transform', `translate(${this.title.sub.x}, ${this.title.sub.y})`)
        .attr('font-size', this.title.sub.tSize).attr('fill', this.title.sub.tColor)
        .text(this.title.sub.name)
      }

      if(this.title.source.visible == 'Y') {
       this.canvasForms
        .append('text')
        .attr('transform', `translate(${this.header.width}, ${this.scroll.viewbox.y - this.header.height - 3})`)
        .attr('font-size', this.title.source.tSize).attr('fill', this.title.source.tColor).attr('text-anchor', 'end')
        .text(this.dataSource.SOURCE)
      }

      if(this.dataSet.length > 0) this.draw_Summary()
      this.draw_Header()
      this.draw_ViewBox()


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
      
    },

  }
}